export default "__VITE_ASSET__9ed9da90__"